import {SubscriptionForm} from './SubscriptionForm.js';
import {Templates} from './Templates.js';

export class Listmonk {	
	static init(script) {
		console.log(`listmonksub :: Listmonk::init(script = `, script, `)`);
		console.log(`src = `, script.getAttribute(`src`));
		Listmonk.insertCss();
		SubscriptionForm.init(script);
	}
	static insertCss() {
		let [css, _] = Templates(`SubscriptionCSS`);
		let c = document.head.firstElementChild;
		if (document.head.firstElementChild) {
			document.head.insertBefore(css, document.head.firstElementChild);
		} else {
			document.head.appendChild(css);
		}
	}
}

if (document.readyState == "loading") {	
    (function(script) {
      document.addEventListener("DOMContentLoaded", function() {
        Listmonk.init(script);
      });
    })(document.currentScript);
} else {
	Listmonk.init(document.currentScript);
}